import { Link } from 'react-router-dom';
import './Footers.css';

export default function Footer() {
  return (
    <>
      <section id="footer">
        <div className="container">
          <div className="row">
            {/* Left Side - Address and Numbers */}
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              {/* <h5>Address:</h5>
              <p>
                <strong>EXPRESS ENGINEERING (Head Office)</strong>,<br />
               4,Power House road,<br />
               TPK ROAD,<br />
                Madurai-625001.
              </p> */}

              <h5>Address:</h5>

<p>
  <strong>EXPRESS ENGINEERING</strong><br />
  <small>(Service E2E - Home Appliance Service Division)</small>
  <br /><br />

  No. 8,<br />
  Sarvodhaya 4th Cross Street,<br />
  Madurai - 625016.
</p>
              {/* <h5>Office Number:</h5>
              <p>
                +91 85262 08035<br />
                 
              </p> */}

               <p>
    <strong>GSTIN:</strong> 33AEPPI2648K2Z7
  </p>

              <h5>  Booking Number:</h5>
              <p>
                +91 777 000 5768<br />
                 
              </p>
              

              
            </div>

            {/* Right Side - Disclaimer, Links, Copyright */}
            <div className="col-lg-6 col-md-6 col-sm-12 col-12">
              <h5>Disclaimer:</h5>
              <p>
                This is an independent service provider offering repair and maintenance for various home appliances.
                We are not affiliated with, authorized by, or endorsed by any appliance manufacturers or brand owners.
                We do not use or display any brand trademarks, logos, or copyrighted materials.
              </p>

              <div className="footer-links">
                <Link to="/terms-conditions"><strong>Terms & Conditions</strong></Link><br />
                <Link to="/privacy-policy"><strong>Privacy Policy</strong></Link><br />
              </div>

              {/* 📌 Designed by */}
              <p>
                {/*<strong>Designed by </strong>
                 <a
                  href="https://e2ewebversesolutions.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  E2E Webverse Solutions
                </a> */}
              </p>

               <p>
        <strong>
          Copyright &copy; {new Date().getFullYear()} Service E2E
        </strong>
      </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
